export class Station {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.name = params.name ? params.name : null
    this.zone = params.zone ? params.zone : null
    this.zoneId = params.zone_id ? params.zone_id : null
    this.editable = params.editable ? params.editable : false
    this.materialLoans = params.materialLoans ? params.materialLoans : []
    this.materialLoanIds = params.material_loan_ids ? params.material_loan_ids : []
    this.accessAreaIn = params.accessAreaIn ? params.accessAreaIn : null
    this.accessAreaInId = params.access_area_in_id ? params.access_area_in_id : null
    this.accessAreaOut = params.accessAreaOut ? params.accessAreaOut : null
    this.accessAreaOutId = params.access_area_out_id ? params.access_area_out_id : null
    this.allowedCurrencies = params.allowedCurrencies ? params.allowedCurrencies : []
    this.allowedCurrencyIds = params.allowed_currency_ids ? params.allowed_currency_ids : []
    this.allowedPaymentMethods = params.allowedPaymentMethods ? params.allowedPaymentMethods : []
    this.allowedPaymentMethodIds = params.allowed_payment_method_ids ? params.allowed_payment_method_ids : []
  }
}
